// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2018-10-01 23:29:24 +0200 (Mon, 01 Oct 2018) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 95987 $
//  Purpose   : domain package
// =============================================================================

export const parts = true
